import { CartModule } from '$modules/cart/cart.module';
import { SharedModule } from '$shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EyePanelComponent } from './eye-panel/eye-panel.component';
import { FooterModule } from './footer/footer.module';
import { HeaderModule } from './header/header.module';
import { MainMenuModule } from './main-menu/main-menu.module';
import { MainSearchModule } from './main-search/main-search.module';
import { OverlayModule } from './overlay/overlay.module';
import { ShellComponent } from './shell.component';
import { SwalComponent } from './swal/swal.component';
import { SwalErrorComponent } from '$shared/components/swal-error/swal-error.component';
import { UserAgreementUpdatingModalComponent } from './user-agreement-updating-modal';

@NgModule({
  declarations: [
    ShellComponent,
    SwalComponent,
    EyePanelComponent,
    SwalErrorComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    HeaderModule,
    FooterModule,
    MainMenuModule,
    MainSearchModule,
    OverlayModule,
    CartModule,
    UserAgreementUpdatingModalComponent,
  ],
  exports: [ShellComponent],
})
export class ShellModule {}
